import React from 'react';
import cs from 'classnames';
import {reduxForm} from 'redux-form';
import {connect} from 'react-redux';
import {getUrlQeury} from '~/misc/formatUrlquery';
import * as modes from '~/modules/modal/modes';
import {modalChange} from '~/modules/modal/actions';
import {signUpV2} from '~/modules/user/actions';
import Button from '~/components/common/Button';
import LabeledInput from '~/components/common/LabeledInputNoClose';
// import DotMcValidate from '~/components/common/DotMcValidate';
import FormHeader from '../FormHeader';
import ErrorBlock from '../Error';
import mapDispatch from '~/misc/mapDispatch';
import TypeSelect from '~/components/common/TypeSelect';
import {formatPhone, formatNumberOnly} from '~/misc/formatPhone';
import authPageCSS from '~/components/authpage.css';
import css from './index.css';
import sharedCSS from '~/components/shared.css';

class SignUpFormV2 extends React.Component {
  constructor(props) {
    super(props);
    this.subMit = this.subMit.bind(this);
    this.wrapClick = this.wrapClick.bind(this);
    this.handlePhone = this.handlePhone.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.handleAuthNumber = this.handleAuthNumber.bind(this);
    this.state = {
      showdot: true,
      phoneFormat: '',
      type: 'mc',
      authNumber: '',
      source: '',
    };
  }
  componentWillMount() {
    const query = getUrlQeury();
    const source = query.utm_source;
    if ((source === 'undefined') || (source === 'null') || !source) {
      this.setState({
        source: '',
      });
    } else {
      this.setState({
        source: source,
      });
    }
  }
  render() {
    const props = this.props;
    return (
      <form data-qa='signup-form'>
        <div className={css.title}>Please sign up for loads details</div>

        <div className={css.inputs}>
          <LabeledInput
            data-qa='first-name-input'
            mods={['wide', 'large']}
            label='First Name'
            {...props.fields.firstName}
          />
          <LabeledInput
            data-qa='last-name-input'
            mods={['wide', 'large']}
            label='Last Name'
            {...props.fields.lastName}
          />
          <LabeledInput
            data-qa='phone-input'
            mods={['wide', 'large']}
            label='Phone Number'
            {...props.fields.phone}
            value={this.state.phoneFormat}
            onChange={this.handlePhone}
          />
          <div className={css.typeSelect}>
            <div className={css.typeSelectLabel}>
              <p>Type</p>
            </div>
            <div className={css.typeSelectContent}>
              <TypeSelect
                {...props.fields.type}
                dropDownId={'typeSelect'}
                onChange={this.handleSelect}
                value={this.state.type}
              />
              <LabeledInput
                data-qa='anth-number-input'
                mods={['wide', 'large']}
                placeholder='Authority number'
                {...props.fields.authNumber}
                onChange={this.handleAuthNumber}
                value={this.state.authNumber}
              />
            </div>

          </div>
          <div className={css.email}>
            <LabeledInput
              data-qa='email-input'
              autoFocus='true'
              mods={['wide', 'large']}
              label='Email'
              {...props.fields.email}
            />
          </div>
          <div className={css.pswd}>
            <LabeledInput
              data-qa='password-input'
              mods={['wide', 'large']}
              label='Password'
              type='password'
              {...props.fields.password}
            />
          </div>
          
          {/* { props.dot_sign_switch === 1
            && <DotMcValidate wrapClick={this.wrapClick} {...props} />
          } */}
        </div>
        <div className={css.buttonWrap}>
          <Button
            data-qa='signup-button'
            mods={['wide', 'large', 'action']}
            onClick={this.subMit}
            className={css.button}
          >
            {props.submitting ? '...' : 'Create Account'}
          </Button>
        </div>

        {/* <ErrorBlock wrap={props.errorWrap}>{props.validateMessage}</ErrorBlock> */}
        <ErrorBlock wrap={props.errorWrap}>{props.signUpErrorMessage}</ErrorBlock>
        <div className={css.footLinks}>
          <span className={cs(sharedCSS.a, 'qa-login-link')} onClick={props.loginV2}>Log in</span>
        </div>
      </form>
    );
  }
  wrapClick(e) {
    const typeValue = e.currentTarget.getAttribute('data-type') !== 'mc';
    this.setState({
      showdot: typeValue,
    });
  }
  handlePhone(e) {
    this.setState({
      phoneFormat: formatPhone(e.target.value),
    });
  }
  handleSelect(e) {
    let limit = e === 'mc' ? 6 : 7;
    let authNumber = this.state.authNumber;
    this.setState({
      type: e,
      authNumber: formatNumberOnly(authNumber, limit),
    });
  }
  handleAuthNumber(e) {
    let limit = this.state.type === 'mc' ? 6 : 7;
    this.setState({
      authNumber: formatNumberOnly(e.target.value, limit),
    });
  }
  subMit() {
    const formData = {};
    const oldField = this.props.fields;
    Object.keys(oldField).forEach((key) => {
      formData[key] = oldField[key].value;
    });

    const data = {
      email: formData.email,
      password: formData.password,
      phone: formatNumberOnly(formData.phone, 10),
      firstName: formData.firstName,
      lastName: formData.lastName,
      type: this.state.type ? this.state.type : 'mc',
      authNumber: formData.authNumber,
      source: this.state.source,
    };
    return this.props.signUp(data);
  }
}


export default connect(
  (state) => ({
    signUpErrorMessage: state.user.signUpErrorMessage,
    dot_sign_switch: state.dots.data.dot_sign_switch,
  }),
  mapDispatch({
    onSubmit: (props, formData) => signUpV2({
      email: formData.email,
      password: formData.password,
      phone: formatNumberOnly(formData.phone, 10),
      firstName: formData.firstName,
      lastName: formData.lastName,
      type: formData.type,
      authNumber: formData.authNumber,
    }),
    signUp: (props, data) => signUpV2(data),
    loginV2: () => modalChange(modes.LOGIN_V2, true),
  })
)(reduxForm(
  {
    form: 'signup',
    fields: [
      'email',
      'password',
      'dot',
      'mc',
      'firstName',
      'lastName',
      'phone',
      'type',
      'authNumber',
    ],

  }
)(SignUpFormV2));



// WEBPACK FOOTER //
// ./src/components/user/SignUpFormV2/index.js